import store from '@/services/store'

const state = {
  isLoggedIn () {
    const user = store.getters.user

    if (!user || !user.id) return false

    // Double check for access token before confirming we're logged in
    return this.hasAccessToken()
  },
  hasAccessToken () {
    // Check the cookies for the existence of access_token
    let cookies = document.cookie ? document.cookie.split('; ') : []
    let jar = {}

    cookies.forEach(c => {
      let crumbs = c.split('=')
      jar[crumbs[0]] = crumbs[1]
    })

    // If no access_token then we're definitely not logged in
    return !!((jar.access_token && jar.access_token !== 'false'))
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  hasAccessToken: state => state.hasAccessToken
}

export default {
  state,
  getters
}
